import { theme } from '../../config/theme';
import get from 'lodash/get';
const tinycolor = require('tinycolor2');

function getColor(token) {
    return get(theme.colors, token);
}

export function isLightColor(token) {
    const colorValue = getColor(token);
    const color = tinycolor(colorValue);
    return color.isLight();
}
